module.exports = __webpack_public_path__ + "static/img/tousu.ffcf169.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tousu.jpg
// module id = WbBD
// module chunks = 1